import React from "react";

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
 label?: React.ReactNode;
 error?: string;
 helperText?: string;
}

export const Radio: React.FC<RadioProps> = ({
 label,
 error,
 helperText,
 className = "",
 id,
 ...props
}) => {
 const radioId = id || `radio-${Math.random().toString(36).substr(2, 9)}`;
 const hasError = !!error;

 const radioClasses = `
  h-4 w-4 text-blue-600 border-gray-300
  focus:ring-2 focus:ring-blue-500
  ${hasError ? "border-red-500" : ""}
  ${className}
 `.trim().replace(/\s+/g, " ");

 return (
  <div>
   <div className="flex items-center">
    <input
     id={radioId}
     type="radio"
     className={radioClasses}
     aria-invalid={hasError ? "true" : undefined}
     aria-describedby={error ? `${radioId}-error` : helperText ? `${radioId}-helper` : undefined}
     {...props}
    />
    {label && (
     <label
      htmlFor={radioId}
      className="ml-2 text-sm font-medium text-gray-700"
     >
      {label}
     </label>
    )}
   </div>
   {error && (
    <p id={`${radioId}-error`} className="mt-1 text-sm text-red-600" role="alert">
     {error}
    </p>
   )}
   {helperText && !error && (
    <p id={`${radioId}-helper`} className="mt-1 text-sm text-gray-500">
     {helperText}
    </p>
   )}
  </div>
 );
};

export default Radio;

